import React, { useState } from 'react';
import ProfileHeader from '../components/Sellers/Profile/ProfileHeader';
import ActionsSidebar from '../components/Sellers/Profile/ActionsSidebar';
import ProfileContent from '../components/Sellers/Profile/ProfileContent';
import SellerProductsContent from '../components/Sellers/Profile/Products/SellerProductsContent';
import { useParams, useLocation } from 'react-router-dom';
import { useGetSellersQuery } from '../store/services/addSellerService';

const SellerProfile: React.FC = () => {
  const { sellerId } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'overview');

  const { data } = useGetSellersQuery({
    page: 0,
    limit: 100,
  });

  const seller = data?.payload?.content?.find((s: any) => s.profileId === sellerId);
  const sellerName = seller?.sellerName;
  const sellerActions = seller?.actions;

  return (
    <div className="flex flex-col gap-6" data-testid="seller-profile-page">
      <ProfileHeader
        sellerName={sellerName}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        sellerId={sellerId}
        canSetupMarketPlace={sellerActions?.canSetupMarketPlace}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {activeTab === 'overview' && (
          <div className="lg:col-span-4 xl:col-span-3">
            <ActionsSidebar actions={sellerActions} />
          </div>
        )}
        <div className={activeTab !== 'overview' ? "lg:col-span-12" : "lg:col-span-8 xl:col-span-9"}>
          {activeTab === 'overview' && (
            <ProfileContent
              sellerName={sellerName}
              sellerId={sellerId}
              canSetupMarketPlace={sellerActions?.canSetupMarketPlace}
            />
          )}
          {activeTab === 'products' && (
            <SellerProductsContent sellerId={sellerId} sellerName={sellerName} />
          )}
          {activeTab === 'statistics' && (
            <div className="bg-white dark:bg-dark-surface p-6 rounded-xl border border-gray-100 dark:border-dark-border shadow-sm" data-testid="seller-statistics-tab">
              <h2 className="text-xl font-bold mb-2">Seller Statistics</h2>
              <p className="text-gray-500">Statistics overview for {sellerName || 'seller'}.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SellerProfile;
